// 关键词 × 品牌覆盖矩阵 mock 数据

// 彩色命中徽章样式
const PILL = 'padding:2px 8px;border-radius:4px;font-size:10px;'
const GREEN = `background:#EAF3DE;color:#27500A;${PILL}`
const RED = `background:#FCEBEB;color:#A32D2D;${PILL}`
const AMBER = `background:#FAEEDA;color:#633806;${PILL}`
const ST_RED = 'color:var(--geo-red);font-size:11px;font-weight:600;'
const ST_GREEN = 'color:var(--geo-green);font-size:11px;font-weight:600;'
const ST_ORANGE = 'color:var(--geo-orange);font-size:11px;font-weight:600;'

// 点阵单元（dots: 0=无 / 1=hit1 / 2=hit2）
const N = { dots: 0, cls: '', empty: '-' }
const D1 = { dots: 1, cls: 'hit1', empty: '' }
const D2 = { dots: 2, cls: 'hit2', empty: '' }

export const mockMatrixHeaders = [
  '监测关键词（代表性）', 'GT7', '小米SU7', '极氪001', '智界S7', '蔚来ET5T', 'GT7状态',
]

export const mockMatrixRows = [
  {
    keyword: '猎装轿跑哪款值得买',
    cells: [
      { text: '✗ 缺席', style: RED },
      { text: '✓', style: GREEN },
      { text: '✓', style: GREEN },
      { text: '✓', style: GREEN },
      { text: '✓', style: GREEN },
    ],
    statusText: '⚠ 竞品全覆盖·GT7缺席', statusStyle: ST_RED,
  },
  {
    keyword: '896线激光雷达哪款车有',
    cells: [
      { text: '✓', style: GREEN },
      { text: '✗', style: RED },
      { text: '✗', style: RED },
      { text: '✗', style: RED },
      { text: '✗', style: RED },
    ],
    statusText: '✓ GT7独有优势词', statusStyle: ST_GREEN,
  },
  {
    keyword: '华为乾崑赤兔平台车型',
    cells: [
      { text: '~ 偶发', style: AMBER },
      { text: '✗', style: RED },
      { text: '✗', style: RED },
      { text: '✓ 优先', style: GREEN },
      { text: '✗', style: RED },
    ],
    statusText: '⚠ 智界S7抢占华为标签', statusStyle: ST_RED,
  },
  {
    keyword: 'GT7 vs 极氪001 怎么选',
    cells: [
      { text: '✗ 缺席', style: RED },
      { text: '✗', style: RED },
      { text: '✓ 优先', style: GREEN },
      { text: '✗', style: RED },
      { text: '✗', style: RED },
    ],
    statusText: '⚠ 对比场景GT7未入名单', statusStyle: ST_RED,
  },
  {
    keyword: '800V超快充猎装轿跑推荐',
    cells: [
      { text: '✗ 缺席', style: RED },
      { text: '✓', style: GREEN },
      { text: '✓', style: GREEN },
      { text: '✗', style: RED },
      { text: '✗', style: RED },
    ],
    statusText: '⚠ GT7核心技术却未被识别', statusStyle: ST_RED,
  },
  {
    keyword: 'GT7盲订值得吗',
    cells: [
      { text: '~ 不完整', style: AMBER },
      { text: '✗', style: RED },
      { text: '✗', style: RED },
      { text: '✗', style: RED },
      { text: '✗', style: RED },
    ],
    statusText: '⚠ 转化信息不完整', statusStyle: ST_ORANGE,
  },
]

export const mockHitMatrix = {
  title: '通用词 × TOP8 品牌命中矩阵',
  note: '● = 1个平台命中，●● = 2个及以上平台命中；用于观察通用购车/技术问题下，AI更容易把哪些品牌纳入候选集。',
  keywordHeader: '关键词 \\ 品牌',
  brands: ['小米SU7', '极氪001', '蔚来ET5T', '智界S7', '腾势Z9GT', '享界S9', '阿维塔06T', '启境GT7'],
  rows: [
    { keyword: '猎装轿跑哪款值得买', cells: [D2, D2, D1, D1, N, N, N, N] },
    { keyword: '25-35万猎装轿跑推荐', cells: [D1, D2, D1, N, D1, N, N, N] },
    { keyword: '高端智能新能源轿跑推荐', cells: [D2, D1, N, D2, D1, N, N, N] },
    { keyword: '800V超快充猎装轿跑推荐', cells: [D2, D1, N, N, D1, N, N, N] },
    { keyword: '华为乾崑赤兔平台车型', cells: [N, N, N, D2, N, D1, N, D1] },
    { keyword: '896线激光雷达哪款车有', cells: [N, N, N, N, N, N, N, D2] },
    { keyword: 'L3级自动驾驶量产车型', cells: [D1, N, N, D1, N, N, N, N] },
    { keyword: 'GT7 vs 极氪001 怎么选', cells: [N, D2, N, N, N, N, N, N] },
    { keyword: 'GT7 vs 小米SU7 怎么选', cells: [D2, N, N, N, N, N, N, N] },
    { keyword: '广汽新能源旗舰车型', cells: [N, N, N, N, N, N, D1, N] },
    { keyword: 'GT7盲订值得吗', cells: [N, N, N, N, N, N, N, D1] },
    { keyword: 'GT7预计交付时间', cells: [N, N, N, N, N, N, N, N] },
  ],
}